// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MetadataVariable
 */
export interface MetadataVariable {
    /**
     * SDTM codelist identifier code
     * @type {string}
     * @memberof MetadataVariable
     */
    codelist_code?: string;
    /**
     * Name of the linked codelist for this variable
     * @type {string}
     * @memberof MetadataVariable
     */
    codelist_ref?: string;
    /**
     * Source of the codelist link (e.g. sdtm)
     * @type {string}
     * @memberof MetadataVariable
     */
    codelist_source?: string;
    /**
     * Data format pattern (e.g. XXXXXXXX-XXXX)
     * @type {string}
     * @memberof MetadataVariable
     */
    data_format?: string;
    /**
     * Per-column decimal scale N for a Decimal format, stored as decimal(38, N). Omitted/absent falls back to the default scale. Ignored for non-Decimal formats.
     * @type {number}
     * @memberof MetadataVariable
     */
    decimal_places?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MetadataVariable
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MetadataVariable
     */
    file_key?: boolean;
    /**
     * Declared value shape, validated at the API. One of Char, Integer, Decimal, Double, Date, Datetime. Drives storage typing (see common/variable_format.py). AI extraction writes directly to DynamoDB and normalizes non-canonical values itself before persistence.
     * @type {string}
     * @memberof MetadataVariable
     */
    format?: MetadataVariableFormatEnum;
    /**
     * 
     * @type {number}
     * @memberof MetadataVariable
     */
    max_length?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MetadataVariable
     */
    order?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MetadataVariable
     */
    populate_for_all?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MetadataVariable
     */
    required?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MetadataVariable
     */
    type?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MetadataVariable
     */
    unique_identifier?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MetadataVariable
     */
    variable_label?: string;
    /**
     * 
     * @type {string}
     * @memberof MetadataVariable
     */
    variable_name?: string;
}


/**
 * @export
 */
export const MetadataVariableFormatEnum = {
    Char: 'Char',
    Integer: 'Integer',
    Decimal: 'Decimal',
    Double: 'Double',
    Date: 'Date',
    Datetime: 'Datetime'
} as const;
export type MetadataVariableFormatEnum = typeof MetadataVariableFormatEnum[keyof typeof MetadataVariableFormatEnum];


/**
 * Check if a given object implements the MetadataVariable interface.
 */
export function instanceOfMetadataVariable(value: object): value is MetadataVariable {
    return true;
}

export function MetadataVariableFromJSON(json: any): MetadataVariable {
    return MetadataVariableFromJSONTyped(json, false);
}

export function MetadataVariableFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetadataVariable {
    if (json == null) {
        return json;
    }
    return {
        
        'codelist_code': json['codelist_code'] == null ? undefined : json['codelist_code'],
        'codelist_ref': json['codelist_ref'] == null ? undefined : json['codelist_ref'],
        'codelist_source': json['codelist_source'] == null ? undefined : json['codelist_source'],
        'data_format': json['data_format'] == null ? undefined : json['data_format'],
        'decimal_places': json['decimal_places'] == null ? undefined : json['decimal_places'],
        'description': json['description'] == null ? undefined : json['description'],
        'file_key': json['file_key'] == null ? undefined : json['file_key'],
        'format': json['format'] == null ? undefined : json['format'],
        'max_length': json['max_length'] == null ? undefined : json['max_length'],
        'order': json['order'] == null ? undefined : json['order'],
        'populate_for_all': json['populate_for_all'] == null ? undefined : json['populate_for_all'],
        'required': json['required'] == null ? undefined : json['required'],
        'type': json['type'] == null ? undefined : json['type'],
        'unique_identifier': json['unique_identifier'] == null ? undefined : json['unique_identifier'],
        'variable_label': json['variable_label'] == null ? undefined : json['variable_label'],
        'variable_name': json['variable_name'] == null ? undefined : json['variable_name'],
    };
}

export function MetadataVariableToJSON(json: any): MetadataVariable {
    return MetadataVariableToJSONTyped(json, false);
}

export function MetadataVariableToJSONTyped(value?: MetadataVariable | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'codelist_code': value['codelist_code'],
        'codelist_ref': value['codelist_ref'],
        'codelist_source': value['codelist_source'],
        'data_format': value['data_format'],
        'decimal_places': value['decimal_places'],
        'description': value['description'],
        'file_key': value['file_key'],
        'format': value['format'],
        'max_length': value['max_length'],
        'order': value['order'],
        'populate_for_all': value['populate_for_all'],
        'required': value['required'],
        'type': value['type'],
        'unique_identifier': value['unique_identifier'],
        'variable_label': value['variable_label'],
        'variable_name': value['variable_name'],
    };
}
